"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ES6 version of settle
Promise.settle = function (promises) {
  var PromiseInspection = function PromiseInspection(fulfilled, value) {
    _classCallCheck(this, PromiseInspection);

    this.fulfilled = fulfilled;
    this.value = value;
  };

  return Promise.all(promises.map(function (p) {
    return (// make sure any values are wrapped in a promise
      Promise.resolve(p).then(function (val) {
        return new PromiseInspection(true, val);
      })["catch"](function (err) {
        return new PromiseInspection(false, err);
      })
    );
  }));
}; // wrapping Promise notation around an ajax call


Promise.ajax = function (options) {
  return new Promise(function (resolve, reject) {
    return $.ajax(options).done(function (response) {
      return resolve(response);
    }).fail(function (xhr, status, err) {
      return reject(err);
    });
  });
};